<div
  (click)="checked.set(!checked())"
  [ngClass]="{ 'bg-anis': checked(), 'bg-white': !checked() }"
  class="inline-block size-6 cursor-pointer select-none rounded-[5px] border border-black transition duration-150">
  <div [ngClass]="{ 'opacity-100': checked(), 'opacity-0': !checked() }" class="transition duration-150">
    <app-svg [inline]="true" src="assets/icons/check.svg" />
  </div>
</div>
